import { Link } from 'react-router-dom';

/**
 * Brand lockup: the Zonta emblem mark + the "Zonta / District 17 · Area 1" wordmark.
 *
 * - Uses the vector emblem (/logo/zonta_emblem.svg) so it stays crisp at any size.
 * - The emblem is maroon on transparent; on the dark footer/sidebar (`light`) it sits
 *   inside a light badge so it remains visible against the maroon background.
 * - Aspect ratio is preserved (fixed height + width:auto); descriptive alt text included.
 *
 * Props:
 *   light    — render wordmark in light colors for dark backgrounds (adds emblem badge)
 *   compact  — emblem only, no wordmark text
 */
export default function Logo({ light = false, compact = false }) {
  return (
    <Link
      to="/"
      className="group flex items-center gap-3"
      aria-label="Zonta District 17 Area 1 — home"
    >
      <span
        className={[
          'flex shrink-0 items-center justify-center overflow-hidden rounded-lg transition-transform duration-200 group-hover:scale-[1.04]',
          light ? 'bg-cream-100 p-1 shadow-brand ring-1 ring-white/20' : '',
        ].join(' ')}
      >
        <img
          src="/logo/zonta_emblem.svg"
          alt="Zonta emblem"
          width="40"
          height="41"
          className="h-9 w-auto select-none"
          draggable="false"
        />
      </span>
      {!compact && (
        <span className="leading-tight">
          <span
            className={`block font-display text-lg font-bold ${light ? 'text-white' : 'text-maroon-700'}`}
          >
            Zonta
          </span>
          <span
            className={`block text-[11px] font-semibold uppercase tracking-wider ${light ? 'text-gold-300' : 'text-ink-muted'}`}
          >
            District 17 · Area 1
          </span>
        </span>
      )}
    </Link>
  );
}
